import { MatMenuModule } from '@angular/material/menu';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LanguageModule } from '../language/language.module';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { TranslationModule } from '../translation/translation.module';
import { FooterModule } from '../footer/footer.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { AddblogComponent } from './blog/addblog/addblog.component';
import { UpdateblogComponent } from './blog/updateblog/updateblog.component';
import { DeleteBlogPopupComponent } from './blog/delete-blog-popup/delete-blog-popup.component';
import { BlogComponent } from './blog/blog.component';
import { FilemanagerModule } from '../filemanager/filemanager.module';
import { HtmleditorModule } from '../htmleditor/htmleditor.module';
import { TinymcehtmleditorModule } from "../tinymcehtmleditor/tinymcehtmleditor/tinymcehtmleditor.module";
import { EditorModule } from '@tinymce/tinymce-angular';
import { FilterModule } from '../filter/filter.module';
import { MatdialogModule } from '../matdialog/matdialog.module';
import { MetaModule } from '../meta/meta.module';
import { BlogNewsComponent } from './blog/blognews/blognews.component';
import { BlogsComponent } from './blog/blogs/blogs.component';
import { MatRadioModule } from '@angular/material/radio';



@NgModule({
    declarations: [AddblogComponent, UpdateblogComponent, DeleteBlogPopupComponent, BlogComponent, BlogNewsComponent, BlogsComponent],
    exports: [AddblogComponent, UpdateblogComponent, DeleteBlogPopupComponent, BlogComponent, BlogNewsComponent, BlogsComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],

    imports: [
        CommonModule,
        LanguageModule,
        RouterModule,
        TranslationModule,
        MatToolbarModule,
        MatButtonModule,
        MatSidenavModule,
        MatIconModule,
        MatDividerModule,
        MatDialogModule,
        MatSelectModule,
        MatMenuModule,
        MatButtonModule,
        MatMenuModule,
        FooterModule,
        FormsModule,
        MatCheckboxModule,
        ReactiveFormsModule,
        DragDropModule,
        HtmleditorModule,
        FilemanagerModule,
        TinymcehtmleditorModule,
        EditorModule,
        FilterModule,
        MatdialogModule,
        MetaModule,
        MatRadioModule
    ]
})
export class BlogModule { }
